export default __webpack_public_path__ + "static/media/icon_excel.8197017a.svg";